import Header from "./Components/Header";
import "../styles/CookClubTerms.css";
import Footer from "./Components/Footer";
import SEO from "./Components/SEO";

function Disclaimer() {
    return (
        <div className="disclaimer-page">
            <Header />
            <SEO
                title="Website Disclaimer | DENNY"
                description="Read the Denny Website Disclaimer covering recipes, nutritional information, competitions, intellectual property, website use and limitations of liability."
                keywords="Denny disclaimer, website disclaimer, recipe disclaimer, nutrition disclaimer, legal, Denny South Africa"
            />

            <div className="cook-club-terms-container">
                <h1>Website Disclaimer</h1>

                <p><strong>Version:</strong> 1.0</p>
                <p><strong>Last Updated:</strong> 21 July 2026</p>

                <h2>1. Introduction</h2>

                <p>
                    Welcome to the Denny website ("Website").
                </p>

                <p>
                    This Website is owned and operated by Denny, a proudly South
                    African food brand within the Libstar Group.
                </p>

                <p>
                    By accessing or using this Website, you acknowledge that you
                    have read, understood and agree to the terms contained in this
                    Disclaimer. If you do not agree with any part of this
                    Disclaimer, you should discontinue using the Website.
                </p>

                <p>
                    This Disclaimer should be read together with the Denny Privacy
                    Policy, Cookies Policy and Website Terms &amp; Conditions.
                </p>

                <h2>2. General Information</h2>

                <p>
                    The information published on this Website is provided for
                    general informational and educational purposes only.
                </p>

                <p>
                    While Denny takes reasonable care to ensure that information
                    published on the Website is accurate at the time of
                    publication, we make no warranties or representations regarding
                    the completeness, accuracy, reliability or suitability of any
                    information contained on the Website.
                </p>

                <p>
                    Information may change without prior notice.
                </p>

                <h2>3. Recipes</h2>

                <p>
                    Recipes provided on this Website are intended to inspire home
                    cooking and enjoyment of food.
                </p>

                <p>Cooking results may vary depending on:</p>

                <ul>
                    <li>Ingredients used</li>
                    <li>Product availability</li>
                    <li>Cooking equipment</li>
                    <li>Cooking methods</li>
                    <li>Individual skill levels</li>
                    <li>Environmental conditions</li>
                </ul>

                <p>
                    Denny cannot guarantee that every user will achieve identical
                    results.
                </p>

                <p>
                    Users should exercise their own judgement when preparing
                    recipes.
                </p>

                <h2>4. Food Allergies and Dietary Requirements</h2>

                <p>
                    Recipes published on this Website may include ingredients that
                    contain or may come into contact with common allergens,
                    including but not limited to:
                </p>

                <ul>
                    <li>Dairy</li>
                    <li>Eggs</li>
                    <li>Wheat</li>
                    <li>Gluten</li>
                    <li>Soy</li>
                    <li>Tree nuts</li>
                    <li>Peanuts</li>
                    <li>Sesame</li>
                    <li>Fish</li>
                    <li>Shellfish</li>
                </ul>

                <p>
                    It remains the responsibility of each individual to carefully
                    read product labels and determine whether ingredients are
                    suitable for their dietary needs or medical conditions.
                </p>

                <p>
                    Persons with food allergies or medical concerns should seek
                    appropriate professional advice before consuming any products
                    or preparing recipes.
                </p>

                <h2>5. Nutritional Information</h2>

                <p>
                    Any nutritional information published on this Website is
                    provided as a general guide only.
                </p>

                <p>Values may vary depending on:</p>

                <ul>
                    <li>Ingredient brands</li>
                    <li>Product substitutions</li>
                    <li>Portion sizes</li>
                    <li>Preparation methods</li>
                    <li>Cooking techniques</li>
                </ul>

                <p>
                    Nutritional information should not be regarded as medical,
                    dietary or professional health advice.
                </p>

                <h2>6. Product Availability</h2>

                <p>
                    Products featured on the Website may not always be available
                    in every retail store, province or country.
                </p>

                <p>
                    Availability may change without notice.
                </p>

                <p>
                    Packaging, branding and product formulations may also change
                    from time to time.
                </p>

                <h2>7. Cooking Advice</h2>

                <p>
                    Cooking techniques, food handling guidance and preparation
                    suggestions are provided as general recommendations only.
                </p>

                <p>Users are responsible for:</p>

                <ul>
                    <li>Following appropriate food safety practices.</li>
                    <li>Cooking foods to safe internal temperatures.</li>
                    <li>Correctly storing ingredients.</li>
                    <li>Maintaining hygienic food preparation environments.</li>
                </ul>

                <p>
                    Denny accepts no responsibility for food spoilage,
                    contamination or injury resulting from improper food
                    preparation.
                </p>

                <h2>8. User-Generated Content</h2>

                <p>
                    The Website may allow users to submit:
                </p>

                <ul>
                    <li>Recipes</li>
                    <li>Photographs</li>
                    <li>Videos</li>
                    <li>Reviews</li>
                    <li>Comments</li>
                    <li>Competition entries</li>
                </ul>

                <p>
                    Opinions expressed by users are their own and do not
                    necessarily reflect the views of Denny or the Libstar Group.
                </p>

                <p>
                    Denny reserves the right to edit, moderate, remove or refuse
                    any content that it considers unlawful, offensive, misleading,
                    defamatory or otherwise inappropriate.
                </p>

                <h2>9. Competitions and Promotions</h2>

                <p>
                    From time to time Denny may conduct competitions, giveaways
                    and promotional campaigns.
                </p>

                <p>
                    Participation is subject to the applicable Competition Terms
                    &amp; Conditions published for each promotion.
                </p>

                <p>
                    Prizes, promotions and campaigns may be amended, suspended or
                    withdrawn where necessary.
                </p>

                <h2>10. External Links</h2>

                <p>
                    This Website may contain links to third-party websites or
                    services.
                </p>

                <p>
                    These links are provided solely for the convenience of users.
                </p>

                <p>Denny does not endorse or accept responsibility for:</p>

                <ul>
                    <li>Third-party content</li>
                    <li>Third-party privacy practices</li>
                    <li>External products or services</li>
                    <li>Information published by external websites</li>
                </ul>

                <p>
                    Users access third-party websites entirely at their own risk.
                </p>

                <h2>11. Intellectual Property</h2>

                <p>
                    Unless otherwise stated, all content published on this Website
                    remains the intellectual property of Denny, the Libstar Group
                    or its licensors.
                </p>

                <p>This includes, but is not limited to:</p>

                <ul>
                    <li>Recipes</li>
                    <li>Photography</li>
                    <li>Videos</li>
                    <li>Graphics</li>
                    <li>Logos</li>
                    <li>Product names</li>
                    <li>Designs</li>
                    <li>Website content</li>
                    <li>Downloadable materials</li>
                </ul>

                <p>
                    No content may be reproduced, distributed or used for
                    commercial purposes without prior written permission.
                </p>

                <h2>12. Website Availability</h2>

                <p>
                    While every effort is made to maintain uninterrupted access,
                    Denny does not guarantee that the Website will always be:
                </p>

                <ul>
                    <li>Available</li>
                    <li>Error-free</li>
                    <li>Secure</li>
                    <li>Virus-free</li>
                    <li>Compatible with every device or browser</li>
                </ul>

                <p>
                    Maintenance, upgrades or technical issues may temporarily
                    affect Website availability.
                </p>

                <h2>13. Limitation of Liability</h2>

                <p>
                    To the fullest extent permitted by applicable law, Denny, the
                    Libstar Group, its directors, employees, agents and service
                    providers shall not be liable for any direct, indirect,
                    incidental or consequential loss or damage arising from:
                </p>

                <ul>
                    <li>Use of the Website</li>
                    <li>Reliance on Website content</li>
                    <li>Recipe preparation</li>
                    <li>Product use</li>
                    <li>Competition participation</li>
                    <li>Technical interruptions</li>
                    <li>Website errors</li>
                    <li>Malware or cyber incidents</li>
                    <li>Loss of data</li>
                    <li>Loss of profits or business opportunities</li>
                </ul>

                <p>
                    Nothing in this Disclaimer excludes liability where such
                    exclusion is prohibited by law.
                </p>

                <h2>14. Medical Disclaimer</h2>

                <p>
                    Information provided on this Website should not be interpreted
                    as medical, nutritional or dietary advice.
                </p>

                <p>
                    Users should always consult an appropriately qualified
                    healthcare professional regarding:
                </p>

                <ul>
                    <li>Allergies</li>
                    <li>Medical conditions</li>
                    <li>Dietary restrictions</li>
                    <li>Nutritional requirements</li>
                </ul>

                <h2>15. Children's Participation</h2>

                <p>
                    Where competitions, promotions or the Denny Cook Club involve
                    minors, participation may require the consent of a parent or
                    legal guardian in accordance with applicable legislation.
                </p>

                <h2>16. Changes to this Disclaimer</h2>

                <p>
                    Denny reserves the right to update or amend this Disclaimer at
                    any time.
                </p>

                <p>
                    The latest version will always be published on the Website
                    together with the revised <strong>Last Updated</strong> date.
                </p>

                <h2>17. Governing Law</h2>

                <p>
                    This Disclaimer shall be governed by and interpreted in
                    accordance with the laws of the Republic of South Africa.
                </p>

                <p>
                    Any disputes arising from the use of this Website shall be
                    subject to the jurisdiction of the South African courts.
                </p>

                <h2>18. Contact Information</h2>

                <p>
                    If you have any questions regarding this Disclaimer, please
                    contact:
                </p>

                <p>
                    <strong>Denny</strong><br />
                    A brand within the Libstar Group<br />
                    Address:<br />
                    12 Barlinka Avenue<br />
                    Montagu<br />
                    6720<br />
                    South Africa
                </p>

                <p>
                    Telephone: +27 23 614 2359<br />
                    {/*Email: [Insert Legal or Information Officer Email Address]*/}
                </p>
            </div>

            <Footer />
        </div>
    );
}

export default Disclaimer;
